import * as React from 'react';
import {
  getProductListings,
  getProductListingsCountFormValues,
  getProductListingsTableState,
} from './EditProductSelectors';
import {useSelector} from 'react-redux';
import {StoreState} from '../../App/initialStore';
import TextBubble from '../../shared/components/TextBubble';

const ProductListingsCount: React.FunctionComponent<{}> = props => {
  const listingsCount = useSelector((state: StoreState) => {
    const initialCount = getProductListingsCountFormValues(state);
    const tableData = getProductListings(state);
    return tableData && 'additionalData' in getProductListingsTableState(state) ? tableData.size : initialCount;
  });
  return <TextBubble text={listingsCount} {...props} />;
};

export default ProductListingsCount;
